import React, {useEffect, useRef, useState} from "react";
import SockJsClient from 'react-stomp';
import confetti from 'canvas-confetti';
import {baseUrl, vtDancerMessageURI, webSocketUrl} from "../../requests/NetworkRequestAuth0";
import {getVenueSession} from "../../requests/AppSession";
import {useNavigate} from "react-router-dom";
import {NumericFormat} from "react-number-format";
import LoginError from "../login/LoginError";
import {Skeleton} from "@mui/material";
import {findStageDisplay} from "../requests/AppRequestStage";
import {useAuth0} from "@auth0/auth0-react";

export default function VTStageDisplay() {
    let navigate = useNavigate();

    const {isLoading, getAccessTokenSilently} = useAuth0();

    let clientRef;

    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [venueImage, setVenueImage] = React.useState(null);

    const [clubErrorMessage, setClubErrorMessage] = React.useState(null);

    const [dancer, setDancer] = React.useState(null);
    const [dancerEffect, setDancerEffect] = React.useState(false);
    const [dancerErrorMessage, setDancerErrorMessage] = React.useState(null);

    const [isPageLoading, setIsPageLoading] = React.useState(true);

    const [tipped, setTipped] = React.useState(false);
    const [tipAmount, setTipAmount] = React.useState(1);
    const [tipErrorMessage, setTipErrorMessage] = React.useState(null);

    const [dancerTotalTipAmount, setDancerTotalTipAmount] = React.useState(0);
    const [dancerTotalTipPercent, setDancerTotalTipPercent] = React.useState(0);
    const [dancerTotalTipGoal, setDancerTotalTipGoal] = React.useState(100);

    const [vt, setVT] = React.useState(null);
    const [vtBeforeError, setVTBeforeError] = React.useState(null);

    const [vtOnPageLoad, setVTOnPageLoad] = React.useState(null);
    const [totalAmountTipped, setTotalAmountTipped] = React.useState(0);

    const [vtErrorMessage, setVtErrorMessage] = React.useState(null);

    const [tableRequestFeatureFlag, setTableRequestFeatureFlag] = useState(false);
    const [tableId, setTableId] = React.useState(null);
    const [hasRequestedTable, setHasRequestedTable] = React.useState(false);
    const [hasTipped, setHasTipped] = useState(false);
    const [minimumTableRequestTip, setMinimumTableRequestTip] = useState(false);
    const [open, setOpen] = useState(false);
    const cancelButtonRef = useRef(null);

    // Tracks the highest $100 milestone already celebrated for the current dancer,
    // so confetti fires once per crossing (100, 200, 300, ...) and not on every re-render.
    const lastConfettiMilestone = useRef(0);

    // Full-screen confetti burst from multiple origins so it pops "everywhere".
    const fireConfetti = () => {
        const count = 400;
        const base = {startVelocity: 45, ticks: 200, zIndex: 9999, gravity: 0.9, scalar: 1.1};
        const bursts = [
            {particleCount: Math.floor(count * 0.3), spread: 70, angle: 60, origin: {x: 0, y: 0.7}},
            {particleCount: Math.floor(count * 0.3), spread: 70, angle: 120, origin: {x: 1, y: 0.7}},
            {particleCount: Math.floor(count * 0.2), spread: 100, angle: 90, origin: {x: 0.5, y: 0.2}},
            {particleCount: Math.floor(count * 0.1), spread: 120, startVelocity: 25, decay: 0.92, origin: {x: 0.5, y: 0.5}},
            {particleCount: Math.floor(count * 0.1), spread: 120, startVelocity: 55, origin: {x: 0.5, y: 0.9}},
        ];
        bursts.forEach((b) => confetti({...base, ...b}));
    };

    // Fire confetti for every $100 boundary crossed between the previous and new total.
    const celebrateMilestones = (newTotal) => {
        const amount = Number(newTotal) || 0;
        const milestone = Math.floor(amount / 100);
        if (milestone > lastConfettiMilestone.current) {
            fireConfetti();
            lastConfettiMilestone.current = milestone;
        }
    };

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.venueId && venueSession.venueId !== null) {
                setVenueId(venueSession.venueId);
                //setVenueName(venueSession.venueName);
            } else {
                navigate('/login/mobile', {replace: true});
            }

            if (!venueSession.stageTipFeatureFlag) {
                navigate('/login/mobile', {replace: true});
            }
        })

        return function cleanup() {

        };
    }, []);

    const getSuccess = async responseJson => {
        setIsPageLoading(false);
        if (
            responseJson &&
            responseJson.id
        ) {
            setVenueImage(responseJson.imgFileName);
            setVenueName(responseJson.name);
            setDancerTotalTipAmount(responseJson.dancerTotalTipAmount)
            setTableRequestFeatureFlag(responseJson.tableRequestFeatureFlag);
            setMinimumTableRequestTip(responseJson.minimumTableRequestTip);
        } else {
            setVtErrorMessage("Error accessing remaining VT, please refresh and verify Internet Connection.");
        }

        if (
            responseJson &&
            responseJson.id &&
            responseJson.dancer &&
            responseJson.dancer.id
        ) {
            setDancer(responseJson.dancer);
        } else {
            setDancerErrorMessage("Error setting dancer, please refresh and verify Internet Connection.");
        }
    };

    const getError = forceLogout => {
        setIsPageLoading(false);
        setClubErrorMessage("Error getting Club information, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            findStageDisplay(venueId, getSuccess, getError, getAccessTokenSilently);
        }
        return function cleanup() {

        };
    }, [isLoading, venueId]);

    const onMessageReceive = (message, topic) => {
        console.log(message);
        console.log(topic);

        if (message && message.venueId) {
            switch (message.messageCode) {
                case "TIP":
                    setDancerTotalTipAmount(message.dancerTotalTipAmount);
                    setDancerTotalTipPercent(message.dancerTotalTipPercent);
                    celebrateMilestones(message.dancerTotalTipAmount);
                    break;
                case "SWITCH_GIRL":
                    setDancerEffect(true);
                    setDancerTotalTipAmount(0);
                    setDancerTotalTipPercent(0);
                    setDancer(message.dancer);
                    lastConfettiMilestone.current = 0;
                    break;
                case "END_TIPPING":
                    setDancerTotalTipAmount(0);
                    setDancerTotalTipPercent(0);
                    setDancer(message.dancer);
                    lastConfettiMilestone.current = 0;
                    break;
            }
        }
    };

    return (
        <>
            <section className="overflow-hidden bg-gray-50 dark:bg-gray-900 py-12 md:py-20 lg:py-24">
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="mt-2">
                        {clubErrorMessage && <LoginError errorMessage={clubErrorMessage}/>}
                    </div>

                    <div className="relative">
                        {/*{!clubErrorMessage && venueImage && <img*/}
                        {/*    className="mx-auto h-8"*/}
                        {/*    src={venueImage}*/}
                        {/*    alt={venueName}*/}
                        {/*/>}*/}
                        {/*{!clubErrorMessage && !venueImage && venueName &&*/}
                        {/*<div className="mx-auto max-w-3xl text-center text-3xl font-medium leading-9 text-black-900">*/}
                        {/*    <p>*/}
                        {/*        {venueName}*/}
                        {/*    </p>*/}
                        {/*</div>}*/}
                        {dancer && <blockquote className="">
                            <div className="mx-auto max-w-6xl text-center text-2xl font-medium leading-9 text-gray-900 dark:text-gray-100">
                                <p>
                                    Now on stage
                                </p>
                            </div>
                            <footer className="mt-4">
                                <div className="md:flex md:items-center md:justify-center">
                                    <div className="md:flex-shrink-0">
                                        {/*<img*/}
                                        {/*    className="mx-auto h-10 w-10 rounded-full"*/}
                                        {/*    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"*/}
                                        {/*    alt=""*/}
                                        {/*/>*/}
                                    </div>
                                    <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                                        {dancerEffect ?
                                            <div
                                                className="animate-spin text-9xl font-medium text-gray-900 dark:text-gray-100">{dancer.name}</div>
                                            :
                                            <div className="text-9xl font-medium text-gray-900 dark:text-gray-100">{dancer.name}</div>
                                        }

                                        {/*<svg className="mx-1 hidden h-5 w-5 text-pink-600 md:block" fill="currentColor" viewBox="0 0 20 20">*/}
                                        {/*    <path d="M11 0h3L9 20H6l5-20z" />*/}
                                        {/*</svg>*/}

                                        {/*<div className="text-base font-medium text-gray-500">CEO, Workcation</div>*/}
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <h4 className="sr-only">Status</h4>
                                    <p className="text-7xl text-center mt-1 font-medium text-gray-900 dark:text-gray-100">
                                        <span className="text-5xl text-pink-600">Stage Tips</span> <NumericFormat
                                        value={dancerTotalTipAmount} displayType={'text'}
                                        decimalScale={2} fixedDecimalScale={true}
                                        thousandSeparator={true} prefix={'$'}/>
                                    </p>
                                </div>

                                {/*<div className="mt-3">*/}
                                {/*    <h4 className="sr-only">Status</h4>*/}
                                {/*    <p className="text-7xl text-center mt-1 font-medium text-gray-900">*/}
                                {/*        <NumericFormat value={dancerTotalTipAmount} displayType={'text'}*/}
                                {/*                       decimalScale={2} fixedDecimalScale={true}*/}
                                {/*                       thousandSeparator={true} prefix={'$'}/>*/}
                                {/*        { } out of GOAL { }*/}

                                {/*        <NumericFormat value={dancerTotalTipGoal} displayType={'text'}*/}
                                {/*                       decimalScale={2} fixedDecimalScale={true}*/}
                                {/*                       thousandSeparator={true} prefix={'$'}/>*/}
                                {/*    </p>*/}
                                {/*    <div className="mt-6" aria-hidden="true">*/}
                                {/*        <div className="overflow-hidden rounded-full bg-gray-200">*/}
                                {/*            <div className="h-2 rounded-full bg-pink-600" style={{ width: dancerTotalTipPercent + '%' }} />*/}
                                {/*        </div>*/}
                                {/*        <div className="mt-6 hidden grid-cols-4 text-sm font-medium text-gray-600 sm:grid">*/}
                                {/*            /!*<div className="text-indigo-600">Copying files</div>*!/*/}
                                {/*            /!*<div className="text-center text-indigo-600">Migrating database</div>*!/*/}
                                {/*            /!*<div className="text-center">Compiling assets</div>*!/*/}
                                {/*            /!*<div className="text-right">Deployed</div>*!/*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                            </footer>
                        </blockquote>}
                        {/*{!dancer && isPageLoading && <CircularProgress color="inherit" size={20}/>}*/}
                        {!dancer && !isPageLoading && <blockquote className="mt-10">
                            <div className="mx-auto max-w-3xl text-center text-2xl font-medium leading-9 text-gray-900 dark:text-gray-100">
                                <p>
                                    No one is on Stage at this time.
                                </p>
                            </div>
                        </blockquote>}
                        {!dancer && isPageLoading && <blockquote className="mt-10">
                            <div className="mx-auto max-w-3xl text-center text-2xl font-medium leading-9 text-gray-900 dark:text-gray-100">
                                <p>
                                    <Skeleton variant="rounded"/>
                                </p>
                            </div>
                        </blockquote>}
                    </div>
                </div>
            </section>
            {venueId &&
            <SockJsClient url={webSocketUrl + '/ws'} topics={[vtDancerMessageURI + venueId]}
                          onMessage={onMessageReceive} ref={(client) => {
                clientRef = client
            }}
                          onConnect={() => {
                              //this.setState({clientConnected: true})
                          }}
                          onDisconnect={() => {
                              // leaveGameSession();
                              // if (onlineGameId && gamePendingStatus) {
                              //     leaveGame(onlineGameId, () => {
                              //     }, () => {
                              //     });
                              // }
                          }}
                          debug={true}/>
            }
        </>
    )
}
